import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import equipamentosDetalhes from './Data';

const Showcase = () => {
  const navigate = useNavigate();

  const todosProdutos = Object.entries(equipamentosDetalhes).map(([nome, dados]) => ({
    nome,
    imagem: dados.imagens?.[0] || "",
    ...dados
  }));

  const [busca, setBusca] = useState("");
  const [produtosFiltrados, setProdutosFiltrados] = useState(todosProdutos);

  const handleInput = (e) => {
    const valor = e.target.value;
    setBusca(valor);
    setProdutosFiltrados(
      todosProdutos.filter((p) =>
        p.nome.toLowerCase().includes(valor.toLowerCase())
      )
    );
  };

  const handleReset = () => {
    setBusca("");
    setProdutosFiltrados(todosProdutos);
  };

  const handleProdutoClick = (produto) => {
    navigate(`/equipamento/${encodeURIComponent(produto.nome)}`, { state: produto });
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      
      <Navbar theme="light" />
      
      <main className="flex-grow container mx-auto px-6 md:px-12 py-12 pt-28 lg:pt-32">
        
        {/* TAG DE ENGENHARIA ADICIONADA PARA MANTER O PADRÃO */}
        <div className="flex items-center gap-4 mb-6">
          <span className="w-12 h-[3px] bg-usifresa-orange"></span>
          <span className="text-xs md:text-sm font-black text-usifresa-blue uppercase tracking-[0.3em]">
            Portfólio
          </span>
        </div>

        <h1 className="text-4xl md:text-5xl font-sans font-black text-usifresa-blue mb-8">Conheça nossas máquinas.</h1>
        

        <div className="flex flex-col md:flex-row justify-between items-center gap-6 mb-12">
          <button 
            onClick={() => window.open('/pdfs/catalogo-completo-usifresa.pdf', '_blank')}
            className="w-full md:w-auto px-8 py-3 bg-usifresa-orange hover:bg-orange-600 text-white font-bold rounded-full shadow-md hover:shadow-lg transition-all"
          >
            Ver catálogo completo
          </button>

          <div className="relative w-full md:w-96">
            <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
              <svg className="h-5 w-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
              </svg>
            </div>
            <input
              type="text"
              className="block w-full pl-11 pr-10 py-3 border border-gray-300 rounded-full leading-5 bg-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-usifresa-light-blue focus:border-usifresa-light-blue sm:text-sm transition-shadow"
              placeholder="Procure por um equipamento..."
              value={busca}
              onChange={handleInput}
            />
            {busca && (
              <button
                onClick={handleReset}
                className="absolute inset-y-0 right-0 pr-4 flex items-center text-gray-400 hover:text-gray-600"
              >
                <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            )}
          </div>
        </div>

        {produtosFiltrados.length === 0 ? (
          <div className="text-center py-20 text-gray-500 text-xl font-light bg-white rounded-2xl shadow-sm border border-gray-100">
            Nenhum equipamento encontrado para "{busca}".
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {produtosFiltrados.map((produto, idx) => (
              <div
                key={idx}
                onClick={() => handleProdutoClick(produto)}
                className="group bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 cursor-pointer border border-gray-100 flex flex-col"
              >
                <div className="relative aspect-video overflow-hidden bg-gray-100 p-4 flex items-center justify-center">
                  <img 
                    src={produto.imagem} 
                    alt={produto.nome} 
                    className="max-w-full max-h-full object-contain group-hover:scale-110 transition-transform duration-500" 
                  />
                </div>
                <div className="p-6 flex flex-col flex-grow relative">
                  <div className="absolute top-0 left-0 w-full h-1 bg-gradient-custom scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left"></div>
                  <h3 className="text-lg font-bold text-usifresa-blue mb-4 group-hover:text-usifresa-light-blue transition-colors">
                    {produto.nome}
                  </h3>
                  <div className="mt-auto flex items-center text-usifresa-orange font-semibold text-sm">
                    Ver detalhes
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 ml-1 group-hover:translate-x-2 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </main>

      <Footer />
    </div>
  );
};

export default Showcase;